export default __webpack_public_path__ + "static/media/I0005.148fcd17.png";